export default "__VITE_ASSET__DChriX$y__"